import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ShoppingBag, Heart } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { useWishlist } from "../../context/WishlistContext";

const NAV = [
  { label: "Accueil", path: "/", testid: "nav-link-accueil" },
  { label: "Nouveautés", path: "/catalog?tag=nouveau", testid: "nav-link-nouveautes" },
  { label: "Le Dressing", path: "/catalog", testid: "nav-link-dressing" },
  { label: "Notre histoire", path: "/histoire", testid: "nav-link-histoire" },
  { label: "Contact", path: "/contact", testid: "nav-link-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { count } = useCart();
  const { count: favCount } = useWishlist();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-[#E8D5CE] bg-[#FBF1EE]/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <button
          className="text-[#2C1A14] md:hidden"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>

        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src="/logo-yoyo.png" alt="Le Dressing de Yoyo" className="h-24 w-auto sm:h-28" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <Link
              key={n.label}
              to={n.path}
              data-testid={n.testid}
              className="text-sm font-medium text-[#2C1A14] transition-colors hover:text-[#D76E4D]"
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-5">
        <Link to="/favoris" data-testid="wishlist-button" aria-label="Favoris" className="relative text-[#2C1A14] transition-colors hover:text-[#D76E4D]">
          <Heart />
          {favCount > 0 && (
            <span data-testid="wishlist-count" className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#2C1A14] text-[10px] font-bold text-white">{favCount}</span>
          )}
        </Link>
        <button
          onClick={() => navigate("/panier")}
          data-testid="cart-button"
          className="relative text-[#2C1A14] transition-colors hover:text-[#D76E4D]"
          aria-label="Panier"
        >
          <ShoppingBag />
          {count > 0 && (
            <span
              data-testid="cart-count"
              className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[#D76E4D] text-[10px] font-bold text-white"
            >
              {count}
            </span>
          )}
        </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-[#E8D5CE] bg-[#FBF1EE] px-4 py-3 md:hidden">
          {NAV.map((n) => (
            <Link
              key={n.label}
              to={n.path}
              data-testid={`${n.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="block py-3 text-base font-medium text-[#2C1A14] hover:text-[#D76E4D]"
            >
              {n.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
